export type AppThemeName = 'light' | 'dark';

export interface AppTheme {
  name: AppThemeName;
  // App layout colors
  appBackground: string;
  surfaceBackground: string;
  surfaceBorder: string;
  textPrimary: string;
  textSecondary: string;
  accentPrimary: string;
  accentGradientFrom: string;
  accentGradientTo: string;

  // Toolbar
  toolbarBackground: string;
  toolbarBorder: string;

  // Chart (Lightweight Charts)
  chartBackground: string;
  chartText: string;
  chartGrid: string;
  chartPriceScaleBorder: string;
  candleUp: string;
  candleDown: string;
  areaTop: string;
  areaBottom: string;
}

export const lightTheme: AppTheme = {
  name: 'light',
  appBackground: '#f5f6fa',
  surfaceBackground: '#ffffff',
  surfaceBorder: '#e8e8e8',
  textPrimary: '#1f1f1f',
  textSecondary: '#666666',
  accentPrimary: '#52c41a',
  accentGradientFrom: '#667eea',
  accentGradientTo: '#764ba2',
  toolbarBackground: '#fafafa',
  toolbarBorder: '#e8e8e8',
  chartBackground: '#ffffff',
  chartText: '#333333',
  chartGrid: 'rgba(197,203,206,0.7)',
  chartPriceScaleBorder: 'rgba(197,203,206,1)',
  candleUp: '#26a69a',
  candleDown: '#ef5350',
  areaTop: 'rgba(255,0,0,0.15)',
  areaBottom: 'rgba(255,0,0,0.15)'
};

// Dark palette inspired by the provided Figma (deep green/teal glow)
export const darkTheme: AppTheme = {
  name: 'dark',
  appBackground: '#0c1210',
  surfaceBackground: '#0f1614',
  surfaceBorder: '#1f2a28',
  textPrimary: '#e6fff3',
  textSecondary: '#98afa6',
  accentPrimary: '#22c55e',
  accentGradientFrom: '#14b8a6',
  accentGradientTo: '#10b981',
  toolbarBackground: '#0c1513',
  toolbarBorder: '#1f2a28',
  chartBackground: '#0b0f0e',
  chartText: '#cfe9df',
  chartGrid: 'rgba(55, 84, 76, 0.35)',
  chartPriceScaleBorder: 'rgba(55,84,76,0.6)',
  candleUp: '#34d399',
  candleDown: '#ef4444',
  areaTop: 'rgba(20, 184, 166, 0.15)',
  areaBottom: 'rgba(20, 184, 166, 0.15)'
};

export const themes: Record<AppThemeName, AppTheme> = {
  light: lightTheme,
  dark: darkTheme,
};


